
  function formatPrice(amount, currency) {
    return (amount / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: currency,
    });
  }

  document.addEventListener('sealsubs:selling_plan_changed', function(e) {
    let quantitySelector = document?.querySelector('.product')?.querySelector('quantity-selector');
    let inputChecked = e?.detail?.element?.querySelector('input[type="radio"]:checked');

    if(quantitySelector && e?.detail?.selling_plan_id) {
      if(e?.detail?.selling_plan_id) {
        document.querySelector('.product').querySelector('quantity-selector').hidden = true;
        quantitySelector.setAttribute('value-old', quantitySelector.querySelector('input[name="quantity"]').value)
        quantitySelector.querySelector('input[name="quantity"]').value = 1; 
      } else {
        document.querySelector('.product').querySelector('quantity-selector').hidden = false; 
        quantitySelector.querySelector('input[name="quantity"]').value = quantitySelector.getAttribute('value-old') ?? 1;
      }
    }

    if(inputChecked) {
      let slsOption = inputChecked?.closest('.sls-option-container');
      let price = slsOption?.querySelector('.sls-price')?.querySelector('.ht-money');
      let form = slsOption?.closest('form');
      let pdpPrice = form.querySelector('.btn-pdp-price');
      if(price && pdpPrice) {
          pdpPrice.innerHTML = '· ' + price.innerHTML;
      }
    }

  });

  document.addEventListener('sealsubs:subscription_widget_created', function(e) {
    let currency = window.currency;
    let symbol = window.symbol;
    let rate = Number(Shopify.currency.rate);
    let element = e.detail.element;
    let dataProduct = JSON.parse(element.getAttribute('data-product'));
    let sellingPlanGroups = dataProduct.selling_plan_groups;

    Object.entries(sellingPlanGroups).forEach(([group, item]) => {
     let sellingPlans = item?.selling_plans[0];
     let prePaidMultiplier = sellingPlans.prePaidMultiplier;
     let priceAdjustments = sellingPlans?.price_adjustments[0];
     if(priceAdjustments) {
        let value = priceAdjustments.value;
        let valueType = priceAdjustments.value_type;

         if(value <= 0) {
            return;
         }

        let optionEl = element.querySelector(`[data-selling-plan-group="${group}"]`);
        if(optionEl) {

          let intervalMoney = setInterval(function() {
            element.querySelectorAll('.ht-money').forEach(money => {
                if(money.classList.contains('changed-price')) {
                  return;
                }

                money.innerHTML =  money.innerHTML.replace('.', ',').replace(symbol,'') + symbol;
                money.classList.add('changed-price');
            })

            if(optionEl.querySelector('.money')) {
              let firstLine = optionEl.querySelector('.sls-label-container.seal-col').querySelector('.sls-selling-plan-group-first-line');
              let lastLine = optionEl.querySelector('.sls-label-container.seal-col').querySelector('.sls-selling-plan-group-options');

              if(!firstLine || !lastLine) {
                return;
              }

              let slsPrice = firstLine.querySelector('.sls-price');
              let slsPriceLast = lastLine.querySelector('.sls-price');
  
              if(slsPrice.classList.contains('rendered-compe-at-price')) {
                return;
              }

              let priceSale = Number(slsPrice.querySelector('.money').innerHTML.replace(',','.').replace(/[^\d.]/g, ''));

              let compeAtPrice = 0;

              if(valueType == 'fixed_amount') {
                if(slsPrice.closest('.sls-selling-plan-group-options')) {
                  value = value / prePaidMultiplier
                }
                value = value * rate;
                let formatPriced = Number(formatPrice(value,currency).replace(symbol, ''));

                compeAtPrice = priceSale + formatPriced;


              }
              if(valueType == 'percentage') {
                compeAtPrice = priceSale * 100 / (100 - value)
              }
              
              if(compeAtPrice <= 0) {
                return
              }
              compeAtPrice = compeAtPrice.toFixed(2);

              let compeAtPriceForPaid = Number(Number(compeAtPrice) / prePaidMultiplier).toFixed(2)

              let elementCompeAtPrice = document.createElement('span');
              elementCompeAtPrice.className = 'compe-at-price';
              elementCompeAtPrice.innerHTML = compeAtPrice.replace('.', ',') + symbol;
              elementCompeAtPrice.style.marginRight = '10px';
              elementCompeAtPrice.style.textDecoration = 'line-through';

              let elementCompeAtPriceForPaid = document.createElement('span');
              elementCompeAtPriceForPaid.className = 'compe-at-price';
              elementCompeAtPriceForPaid.innerHTML = compeAtPriceForPaid.replace('.', ',') + symbol;
              elementCompeAtPriceForPaid.style.marginRight = '10px';
              elementCompeAtPriceForPaid.style.textDecoration = 'line-through';


              slsPrice.insertBefore(elementCompeAtPrice, slsPrice.children[0]);
              slsPrice.classList.add('rendered-compe-at-price');

              slsPriceLast.insertBefore(elementCompeAtPriceForPaid, slsPriceLast.children[0]);
              slsPriceLast.classList.add('rendered-compe-at-price');
            }
          })
        }
     }
    });

  });